import { Injectable } from "@angular/core";
import {
  IExternalRessource,
  IOComponent,
  IObservation,
  IObservationDefinition,
  IObservationParam,
  IObservationParamWithObsDefinition,
  IObservationWithoutComponents,
  IStreamGraphLine,
} from "@comunicare/comunicare-interfaces";
import { IObservationService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable } from "rxjs";

/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

@Injectable({
  providedIn: "root",
})
export class ObservationsService implements IObservationService {
  list(patientId: string, fromDate?: string, toDate?: string, computeNorms?: boolean): Observable<IObservation[]> {
    throw new Error("Method not implemented.");
  }
  listDef(caremateId?: string, loincs?: string[]): Observable<IObservationDefinition[]> {
    throw new Error("Method not implemented.");
  }
  listStream(patientId: string, loincs?: string[]): Observable<string[]> {
    throw new Error("Method not implemented.");
  }
  listParams(includeObsDef?: boolean): Observable<IObservationParamWithObsDefinition[]> {
    throw new Error("Method not implemented.");
  }
  listOnlineDeviceData(
    patientId: string,
    startDate: string,
    endDate: string,
    externalRessourceRef: string,
    loinc?: string,
    componentLoincs?: string[]
  ): Observable<IStreamGraphLine[]> {
    throw new Error("Method not implemented.");
  }
  listStreamObservationsDevices(patientId: string, loinc?: string): Observable<IExternalRessource[]> {
    throw new Error("Method not implemented.");
  }
  showPictures(component: IOComponent, name: string, allObservations: IObservation[]): void {
    throw new Error("Method not implemented.");
  }
  getComponent(observation: IObservation, code: string): IOComponent {
    throw new Error("Method not implemented.");
  }
  openAlertHistory(observation: IObservation | IObservationWithoutComponents, obsDefinition: IObservationDefinition[]): void {
    throw new Error("Method not implemented.");
  }
  createObservationDef(obsDef: IObservationDefinition, obsParam: IObservationParam): Observable<IObservationDefinition> {
    throw new Error("Method not implemented.");
  }
  getObservationsByQR(questionnaireResponseRef: string): Promise<IObservation[]> {
    throw new Error("Method not implemented.");
  }
  exportObservations(
    patientId: string,
    startDate: string,
    endDate: string,
    obsCodes: string[],
    lang: string,
    docType: string
  ): Observable<Blob> {
    throw new Error("Method not implemented.");
  }
  showGraph(valueArray: number[][]): void {
    throw new Error("Method not implemented.");
  }
}
